<template>
    <div class="flex-1 min-w-0">
        <h1 class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
            {{ title }}<br />
        </h1>
        <Breadcrumb v-if="pages" class="mt-3" :pages="pages" />
    </div>
</template>

<script>
import Breadcrumb from "../Components/Breadcrumb";

export default {
    name: "PageTitle",
    components: {
        Breadcrumb,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        pages: {
            type: Array,
            required: false,
        },
    },
};
</script>

<style scoped></style>
